var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.loginRequired)?_c('router-view'):_c('div',[_c('OnBoardingLoader',{attrs:{"title":'Verifying User',"description":'Give us a minute, as we are processing your request.'}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }